import React from 'react';
import { IssuedInvoice } from '../../billing/types';
import { ConfirmModal } from '../../commons/components/ConfirmModal';
import { InvoiceTable } from '../../billing/components/InvoiceTable';

export const FinancialTemplatePayInvoicesModal = (props: {
  invoices: IssuedInvoice[];
  onClose: () => void;
}) => {
  const { invoices, onClose } = props;
  return (
    <ConfirmModal
      title="Please pay at least one of your outstanding invoices"
      footer={{ type: 'show' }}
      onClose={() => {
        onClose();
      }}
    >
      <div className="cancellation-intro__description">
        <span>To receive a financial template, at least one outstanding invoice must be paid.</span>
        <InvoiceTable invoices={invoices} header="Outstanding invoices" context="pause" />
      </div>
    </ConfirmModal>
  );
};
